class PaymentTypeSerializer {
  static deSerialize(data) {
    return {
      description: data.ComoPaga,
      detail: data.Detalle,
      id: data.IDFormaPago,
      references: data.Referencias ? data.Referencias.map(item => ({
        id: item.ID,
        code: item.Texto,
        name: item.Descripcion,
      })) : [],
      typeReference: data.IDReferencias || 0,
    };
  }
}

export { PaymentTypeSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/PaymentTypeSerializer.js